import { getMediaVideos } from '@/api/open'
import infiniteScroll from './Scroll'

export default {
    directives: { infiniteScroll },
    components: {
    },
    model: {
        prop: 'ids',
        event: 'change'
    },
    props: ['advertiserId', 'ids', 'maxNum', 'media', 'outId', 'materialSourceType', 'seriesId'],
    data () {
        return {
            loading: false,
            finished: false,
            busy: false,
            coverLoading: false,
            videos: [],
            currentIds: [],
            page: 1,
            show: false,
            currentVideo: null,
            queryParam: {},
            video_total: null,
            // 悬浮预览卡片相关
            previewVisible: false,
            previewCardStyle: {},
            previewTimer: null,
            hideTimer: null,
        }
    },
    beforeDestroy() {
        // 组件销毁时，移除全局的键盘事件监听器
        window.removeEventListener('keydown', this.handleKeyDown);
        // 移除滚动监听
        this.removeScrollListener();
        // 清除定时器
        if (this.previewTimer) clearTimeout(this.previewTimer);
        if (this.hideTimer) clearTimeout(this.hideTimer);
        // 移除 append 到 body 的悬浮卡片节点
        this.removePreviewCard();
    },
    computed: {},
    watch: {
        ids(val) {
            // 外部ids变化（如切换素材来源Tab清空）时同步内部选中状态
            this.currentIds = Object.assign([], val || [])
        },
        show(value) {
            if (!value) {
                this.videos = []
                this.finished = false
                this.page = 1
                this.previewVisible = false
                this.currentVideo = null
                return false
            }
            this.getData()
        }
    },
    mounted () {
        // 组件挂载时，添加全局的键盘事件监听器
        window.addEventListener('keydown', this.handleKeyDown);
        this.currentIds = Object.assign([], this.ids)
        this.maxNum = this.num || this.maxNum
        // 添加滚动监听，滚动时隐藏预览卡片
        this.$nextTick(() => {
            const wrapper = this.$el.querySelector('.video-select-wrapper')
            if (wrapper) {
                wrapper.addEventListener('scroll', this.onScrollHidePreview)
            }
            // 把悬浮卡片移到 body 下，避免被 modal 层叠上下文遮挡
            this.appendToBody()
        })
    },
    methods: {
        handleKeyDown(event) {
            if (event.key === 'Enter') {
                this.search()
            }
        },
        search() {
            this.videos = []
            this.page = 1
            this.getData()
        },
        resetSearch() {
            this.videos = []
            this.page = 1
            this.queryParam = {}
            this.getData()
        },
        handleInfiniteOnLoad() {
            if (this.finished || this.loading) {
                return false
            }
            this.getData()
        },
        getData() {
            // console.log('this.currentIds', this.currentIds)
            // 新的数组，用于存储提取出的material_id
            let materialIds = [];
            // 遍历原始数组，提取material_id
            this.currentIds.forEach(item => {
                if (this.media === 'kuaishou') {
                    materialIds.push(item.id);
                } else {
                    materialIds.push(item.material_id);
                }
            });

            const json = {
                page: this.page,
                page_size: 100,
                name: this.queryParam.name,
                material_id: this.queryParam.material_id,
                current_material_ids: materialIds,
            }
            if (this.outId) {
                json.out_id = this.outId
            } else {
                json.advertiser_id = this.advertiserId
            }
            if (this.queryParam.date && this.queryParam.date.length === 2) {
                json.started_at = this.queryParam.date[0]
                json.finished_at = this.queryParam.date[1]
            }
            // 快手AI推荐视频来源
            if (this.materialSourceType === '3' || this.materialSourceType === 3) {
                json.material_source_type = '3'
                if (this.seriesId) {
                    json.series_id = this.seriesId
                }
            }
            
            this.loading = true
            getMediaVideos(json).then(res => {
                this.page++
                this.loading = false
                this.video_total = res.data.video_total
                if (res.data.list.length === 0) {
                    this.finished = true
                }
                this.videos = this.videos.concat(res.data.list)
                // this.videos = [...new Map(this.videos.map(item => [item.material_id, item])).values()];

                // console.log(this.videos)
                // let videoIds = new Set(this.videos.map(video => video.id));
                // this.currentIds = this.currentIds.filter(item => videoIds.has(item.id));

                //巨量过滤掉尺寸不合适的视频
                if (this.media ==='juliang') {
                    this.currentIds.forEach(element => {
                        let video = this.videos.find(v => v.material_id === element.material_id);
                        if (video.inefficient) {
                            element.inefficient = video.inefficient;
                        }
                    });

                    this.currentIds = this.currentIds.filter(item => {
                        // 确保 item 包含 width 和 height 属性
                        if (!item.width || !item.height) {
                            return false;
                        }
                        // if (item.width!=720 || item.height!=1280) {
                        //     return false;
                        // }
                        // 计算比例
                        const ratio = item.width / item.height;
                        // 检查比例是否等于 0.5625 或 1.7778（四舍五入保留4位小数）
                        const ratioRounded = Number(ratio.toFixed(4));
                        return ratioRounded === 0.5625 || ratioRounded === 1.7778;
                    });

                    this.currentIds = this.currentIds.filter(item => {
                        let res = true
                        // 确保 item 包含 width 和 height 属性
                        if (item.inefficient && item.inefficient === true) {
                            res = false
                        }
                        return res
                    });
                }
                // this.currentIds = this.videos.filter(value => this.currentIds.includes(value));
            }).finally(() => {
                this.loading = false
            })
        },
        changeVideoId(video) {
            for (const key in this.currentIds) {
                if (this.currentIds[key].id === video.id) {
                    delete this.currentIds[key]
                    this.currentIds = this.currentIds.filter(v => {
                        return v !== null
                    })
                    return true
                }
            }
            if (this.currentIds.length >= this.maxNum) {
                return this.$message.error(`当前最多支持选择${this.maxNum}个视频`)
            }
        
            this.currentIds.push(video)

            //巨量过滤掉尺寸不合适的视频
            if (this.media ==='juliang') {
                this.currentIds = this.currentIds.filter(item => {
                    // 确保 item 包含 width 和 height 属性
                    if (!item.width || !item.height) {
                        return false;
                    }
                    // if (item.width!=720 || item.height!=1280) {
                    //     return false;
                    // }
                    // 计算比例
                    const ratio = item.width / item.height;
                    // 检查比例是否等于 0.5625 或 1.7778（四舍五入保留4位小数）
                    const ratioRounded = Number(ratio.toFixed(4));
                    return ratioRounded === 0.5625 || ratioRounded === 1.7778;
                });

                this.currentIds = this.currentIds.filter(item => {
                    let res = true
                    // 确保 item 包含 width 和 height 属性
                    if (item.inefficient && item.inefficient === true) {
                        res = false
                    }
                    return res
                });
            }
        },
        videoSelected(video) {
            // console.log('this.currentIds', this.currentIds)
            let ids = this.currentIds.map(item => item.id);
            let exists = ids.includes(video.id);
            if (exists) {
                return true
            }
            return false

            // for (const key in this.currentIds) {
            //     const item = this.currentIds[key]
            //     if (item.id !== video.id) {
            //         continue
            //     }
            //     return true
            // }
            // return false
        },
        clearSelected () {
            this.currentIds = []
            this.complete()
        },
        preview(video, event) {
            // 清除隐藏定时器
            if (this.hideTimer) {
                clearTimeout(this.hideTimer)
                this.hideTimer = null
            }
            // 防抖：延迟200ms再显示，避免快速划过时闪烁
            if (this.previewTimer) clearTimeout(this.previewTimer)
            // 必须在 setTimeout 外保存 target 引用，否则事件结束后 currentTarget 会变为 null
            const target = event.currentTarget
            this.previewTimer = setTimeout(() => {
                if (!target) return
                this.currentVideo = video
                this.calculatePosition(target)
                this.previewVisible = true
            }, 200)
        },
        hidePreview() {
            // 清除显示定时器
            if (this.previewTimer) {
                clearTimeout(this.previewTimer)
                this.previewTimer = null
            }
            // 延迟关闭，让鼠标有机会移入卡片
            this.hideTimer = setTimeout(() => {
                this.previewVisible = false
                this.currentVideo = null
            }, 200)
        },
        onCardMouseEnter() {
            // 鼠标移入卡片时，取消隐藏
            if (this.hideTimer) {
                clearTimeout(this.hideTimer)
                this.hideTimer = null
            }
        },
        onCardMouseLeave() {
            // 鼠标移出卡片时，隐藏
            this.hidePreview()
        },
        onScrollHidePreview() {
            // 滚动时隐藏预览卡片
            if (this.previewVisible) {
                this.previewVisible = false
                this.currentVideo = null
            }
        },
        removeScrollListener() {
            try {
                const wrapper = this.$el && this.$el.querySelector('.video-select-wrapper')
                if (wrapper) {
                    wrapper.removeEventListener('scroll', this.onScrollHidePreview)
                }
            } catch (e) {
                // ignore
            }
        },
        appendToBody() {
            // 把悬浮卡片节点移到 body 下，脱离 modal 的层叠上下文
            const card = this.$refs.previewCard
            if (card && card.parentNode !== document.body) {
                document.body.appendChild(card)
            }
        },
        removePreviewCard() {
            const card = this.$refs.previewCard
            if (card && card.parentNode) {
                card.parentNode.removeChild(card)
            }
        },
        calculatePosition(el) {
            const rect = el.getBoundingClientRect()
            const cardWidth = 320
            const gap = 10
            const winH = window.innerHeight

            // 根据视频比例预估卡片高度（竖版9:16≈569，横版16:9≈180）
            let cardHeight = 569
            if (this.currentVideo && this.currentVideo.ratio === 1.7778) {
                cardHeight = 180
            }
            // 不超过视口高度
            cardHeight = Math.min(cardHeight, winH - gap * 2)

            // 默认在右侧弹出，垂直方向与视频项顶部对齐
            let left = rect.right + gap
            let top = Math.max(gap, rect.top)

            // 右侧空间不足时，改为左侧弹出
            if (left + cardWidth > window.innerWidth - gap) {
                left = Math.max(gap, rect.left - cardWidth - gap)
            }

            // 垂直方向智能避让：下方空间不足时，向上偏移使卡片完整显示
            if (top + cardHeight > winH - gap) {
                top = winH - cardHeight - gap
            }
            // 确保不超出顶部
            if (top < gap) {
                top = gap
            }

            this.previewCardStyle = {
                left: left + 'px',
                top: top + 'px',
            }
        },
        close() {
            this.show = false
            this.currentIds = Object.assign([], this.ids)
        },
        complete() {
            this.$emit('change', Object.assign([], this.currentIds))
            this.show = false
        },
        selectAll () {
            for (const key in this.videos) {
                let thisVideo = this.videos[key]
                if (key < this.maxNum) {
                    //选择小于最多视频的
                    if (!this.videoSelected(thisVideo)) {
                        //未选择的，选择
                        if (this.media !='juliang' || this.media ==='juliang' && thisVideo.width && thisVideo.height && (thisVideo.width / thisVideo.height === 0.5625 || Number((thisVideo.width / thisVideo.height).toFixed(4)) === 1.7778)) {
                            this.currentIds.push(thisVideo) 
                        }
                      
                    }
                }
             
            }
          
            // console.log(this.currentIds)

           
            if (this.media ==='juliang') {
                 //巨量过滤掉尺寸不合适的视频, 低效的视频
                this.currentIds = this.currentIds.filter(item => {
                    // 确保 item 包含 width 和 height 属性
                    if (!item.width || !item.height) {
                        return false;
                    }
                    // if (item.width!=720 || item.height!=1280) {
                    //     return false;
                    // }
                    // 计算比例
                    const ratio = item.width / item.height;
                    // 检查比例是否等于 0.5625 或 1.7778（四舍五入保留4位小数）
                    const ratioRounded = Number(ratio.toFixed(4));
                    let res = ratioRounded === 0.5625 || ratioRounded === 1.7778;
                    return res
                });

                // console.log('this.currentIds', this.currentIds)
                 //巨量过滤掉低效的视频
                 this.currentIds = this.currentIds.filter(item => {
                    let res
                    // 确保 item 包含 width 和 height 属性
                    if (item.inefficient && item.inefficient == true) {
                        res = false
                    } else {
                        res = true
                    }
                    return res
                });
            }

           
        },
    }
}
